import React from 'react'
import { useTranslation } from 'react-i18next'
import cl from 'classnames'

import { Icon } from 'Shared/atoms'
import { Button } from 'Shared/molecules'
import Modal from 'Shared/organisms/Modal/Modal'

import styles from './styles.module.scss'

const { ModalBody, ModalFooter } = Modal

interface Props {
	handleDiscard: () => void
	handleContinue: () => void
}

const DiscardChangesModal: React.FC<Props> = ({ handleContinue, handleDiscard }) => {
	const { t } = useTranslation()
	return (
		<>
			<ModalBody>
				<div className={cl(styles.warningInfo, styles.center)}>
					<Icon className={styles.warningIcon} type="warning" />
					<p>{t('partials:discard.modal.description')}</p>
				</div>
			</ModalBody>
			<ModalFooter>
				<Button btnType="secondary" size="small" onClick={handleDiscard}>
					{t('partials:discard.modal.leaveAndDiscard')}
				</Button>
				<Button
					className={styles.continueBtn}
					btnType="primary"
					size="small"
					onClick={handleContinue}
				>
					{t('partials:discard.modal.continue')}
				</Button>
			</ModalFooter>
		</>
	)
}

export default DiscardChangesModal
